/* global __CLIENT__ */

import React, { PureComponent } from 'react';

/**
 * Higher-order component to supply a global async object as property
 * Implememnted subject to client-side check, i.e. assumes window is available
 */
const AsyncScriptWrapper = (WrappedComponent, config) => class extends PureComponent {
  constructor(props) {
    super(props);
    this.script = document.getElementById(config.id);
    this.state = {
      ready: false,
    };
  }

  componentDidMount() {
    if (this.props[config.propName]) {
      // Global already supplied by props
      this.ready();
      // Check whether the global has already loaded or not
    } else if (this.script) {
      if (typeof window[config.global] === 'undefined') {
        this.script.addEventListener('load', this.ready);
      } else {
        // Already loaded, party on
        this.ready();
      }
    }
  }

  componentWillUnmount() {
    if (this.script) {
      // Safely remove (ignored if it was never added)
      this.script.removeEventListener('load', this.ready);
    }
  }

  ready = () => {
    // Set ready state, triggering render
    this.setState({
      ready: true,
    });
  }

  render() {
    if (this.state.ready) {
      const props = {
        ...this.props,
        [config.propName]: this.props[config.propName] || window[config.global],
      };
      return <WrappedComponent {...props} />;
    }
    return <p>Loading</p>;
  }
};

/**
 * Wrapper for higher-order component on the client
 */
const withAsyncScript = (Component, config) => {
  if (__CLIENT__) {
    return AsyncScriptWrapper(Component, config);
  }
  return Component;
};

module.exports = {
  withAsyncScript,
};



// WEBPACK FOOTER //
// ./app/src/components/AsyncScriptWrapper/AsyncScriptWrapper.react.js